/**
 * Waarschuwing in de laatste 5 minuten vóór het uitloggen wegens stilte
 * (chatters, 03-10-2026). Een eigen onderdeel, zodat alleen deze balk elke
 * seconde opnieuw tekent en niet de hele Layout. De knop is zelf een klik en
 * telt dus als activiteit.
 */
import { useInactiviteit } from '../lib/inactiviteit'

export function InactiviteitBalk({ aan }: { aan: boolean }) {
  const resterend = useInactiviteit(aan)
  if (resterend == null) return null
  const sec = Math.max(0, Math.ceil(resterend / 1000))
  const tijd = `${Math.floor(sec / 60)}:${String(sec % 60).padStart(2, '0')}`
  return (
    <div role="alert" style={{
      position: 'fixed', top: 0, left: 0, right: 0, zIndex: 99999, display: 'flex', gap: 12,
      alignItems: 'center', justifyContent: 'center', flexWrap: 'wrap', padding: '10px 16px',
      background: 'var(--warn, #b7791f)', color: '#fff', fontSize: 13.5,
    }}>
      <span>You will be signed out in <b className="mono">{tijd}</b> because of inactivity.</span>
      <button className="btn sm" type="button">Stay signed in</button>
    </div>
  )
}
